export default __webpack_public_path__ + "static/media/grading-confusion-matrix-tabel-en.e91e711a.png";